import React from "react";
import ErrorGeneric from "@pages/Error/components/ErrorGeneric";
const Error404: React.FC = () => {
  const handleReload = () => {
    window.location.href = "/assistant";
  };

  return (
    <ErrorGeneric
      errorTitle="Page Not Found"
      errorDescription="The page you are looking for does not exist or has been moved."
      errorImage="/error500.svg"
      handleReload={handleReload}
    />
  );
};

export default Error404;
